import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  return (
    <React.Fragment>
      <SEO title="Virtual Meeting | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Virtual Meeting"
        content="For Participants"
        contentTwo="Virtual Meeting"
        linkage="/"

      />

      <EmptyTwo>
        {/* <div className="entry-content title-center">  */}
        {/* <h3>The specific information will be announced later. </h3> */}
        {/* </div> */}

        <div className="entry-content">
           <h1>Virtual Meeting</h1>
    <p>Considering the current challenges of international travel, ICSI&apos;2025 offers an online participation option for authors who are unable to attend in person. Authors can join the conference remotely using the designated online conference software.</p>
    <p>The ICSI Organizing Committee has selected Zoom as the platform for the online conference. Zoom is a globally recognized and widely used virtual meeting software that ensures seamless communication and collaboration. With its high-definition video, crystal-clear audio, and advanced security features, attendees can participate in sessions, engage in discussions, and network with peers from around the world effortlessly.</p>
    <p>To join the conference, please visit the Zoom website (<a href="https://zoom.us/">https://zoom.us/</a>) and download the software if you haven&apos;t already. The meeting room numbers and access links will be provided in the conference schedule and communicated to registered participants prior to the event.</p>
    <p>The room numbers for the meetings are listed below.</p>

    <table>
        {/* <caption>Online Meeting Room</caption> */}
        <thead>
            <tr>
                <th>Room Name</th>
                <th>Room Code</th>
                <th>Agenda</th>
                <th>Time</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Opening Ceremony</td>
                <td>298 329 7987</td>
                <td>Opening Ceremony</td>
                <td>08:30 - 12:00, July 12th</td>
            </tr>
            <tr>
                <td>Online Room 1</td>
                <td>298 329 7987</td>
                <td>Parallel Session 4</td>
                <td rowSpan={3}>13:40 - 17:00, July 12th</td>
            </tr>
            <tr>
                <td>Online Room 2</td>
                <td>901 749 7156</td>
                <td>Parallel Session 5</td>
            </tr>
            <tr>
                <td>Online Room 3</td>
                <td>249 881 9024</td>
                <td>Parallel Session 6</td>
            </tr>
        </tbody>
    </table>

     <h3>How to Submit video</h3>
          <br></br>
          <div >
            The ICSI&apos;2025 conference supports the submission of speech videos to participate in the conference. If your speech time conflicts with your schedule, you can submit a 15-minute video, which will be played by the conference team.
            <br></br>
            <br></br>

            The video should be around 15 minutes long, using a PowerPoint presentation to introduce the content of your paper. The language should be English, and the resolution should be 720P or higher. We recommend using Tencent Meeting(VooV Meeting) or Zoom to record the video.
            <br></br>
            <br></br>
            The recorded video needs to be uploaded to the network disk and submitted to the conference team in the form of a link. It is recommended to use Alibaba Cloud or Baidu Cloud. And It is recommended to use Google Drive in countries and regions other than China. The video needs to be submitted to the conference team two days in advance. 
            You can submit the video by sending the video link via email to the conference committee at icsi2025@iasei.org.
            <br></br>
            <br></br>
            <strong>
              Please note: Authors submitting videos are encouraged to participate in the opening ceremony and award ceremony of the conference.
            </strong>
          </div>

        </div>
        {/* <div className="entry-content">
          <p>&nbsp;</p>
          <p>&nbsp;</p>


        </div> */}
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Venue;
